export const filterDate = (date: string) => {
  const parseDate = new Date(date)
  return parseDate.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

export const filterDateDM = (date: string) => {
  const parseDate = new Date(date)
  return parseDate.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
  })
}

export const filterDateTime = (date: string) => {
  const parseDate = new Date(date)
  return parseDate.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const filterDateNumeric = (date: string) => {
  const parseDate = new Date(date)
  return parseDate.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  })
}
